//import { useState } from "react"

export const useDoubleRequestPreventor = () => {
  //const [lastParams, setLastParams] = useState(null)
  //let varParmas: any = null
  const check = (params) => {
    // bypassing for now
    // to many side effects, maybe add timer?
    return false
    // const double =
    //   JSON.stringify(params) === JSON.stringify(lastParams) ||
    //   JSON.stringify(params) === JSON.stringify(varParmas)

    // setLastParams(params)
    // varParmas = params
    // return double
  }

  return { check }
}
